module.exports = __webpack_public_path__ + "img/socks.be5030ca.webp";